export type MessageCatalog = Record<string, string>

export const getTranslatedMessages = (
  messages: MessageCatalog | undefined
): MessageCatalog =>
  Object.fromEntries(
    Object.entries(messages ?? {}).filter(([, message]) => message !== '')
  )

export const mergeMessages = (
  baseMessages: MessageCatalog | undefined,
  overrideMessages: MessageCatalog | undefined
): MessageCatalog => ({
  ...getTranslatedMessages(baseMessages),
  ...getTranslatedMessages(overrideMessages),
})
